import React from "react";
import { Link } from "react-router-dom";
import './BlogContent.css';

// Importing images
import YahariOre from '../assets/images/Yahari Ore no Seishun Love Comedy wa Machigatteiru..png';
import seasea from '../assets/images/sea-sea.jpg';
import Shigatsu from '../assets/images/Shigatsu -Wa- Kimi -No -Uso.png';
import Hinata5 from '../components/Blog/BlogAssets/images/Haikyu/Hinata5.webp';
import coachf from '../components/Blog/BlogAssets/images/GiantKilling/coachf.webp';

const BlogContent = () => {
  return (
    <section className="blog-section">
      {/* Header Section */}
      <div className="blog-header">
        <div className="blog-title-container">
          <h2 className="blog-title"></h2>
          <p className="blog-subtitle"></p>
        </div>
      </div>

      {/* Layout Section with Left and Right Parts */}
      <div className="blog-layout">
        {/* Left Section with Main Blog Content */}
        <div className="blog-main-content">
          <h2 className="blog-recent-posts-title"></h2>

          {/* Main Blog Post */}
          <div className="blog-post">
            <Link to="/new-blog-home/article/1" className="blog-post-image-link">
              <div className="blog-post-image-container">
                <img
                  className="blog-post-image"
                  src={YahariOre}
                  alt="Yahari Ore no Seishun Love Comedy wa Machigatteiru Review"
                />
                <div className="blog-post-overlay">
                  <p className="blog-overlay-description">
                    The story follows two loners, the pragmatic Hachiman Hikigaya and beautiful Yukino Yukinoshita, who despite their varying personalities and ideals, offer help and advice to others as part of their school's Service Club...
                  </p>
                  <div className="blog-tags-overlay">
                    <span className="blog-tagoverlay">Anime</span>
                    <span className="blog-tagoverlay">Comedy</span>
                    <span className="blog-tagoverlay">Romance</span>
                  </div>
                </div>
              </div>
            </Link>
            <div className="blog-post-content">
              <p className="blog-author"> • 20 Sep 2024</p>
              <Link to="/new-blog-home/article/1" className="blog-post-title-link">
                <h3 className="blog-post-title">Yahari Ore no Seishun Love Comedy wa Machigatteiru.</h3>
              </Link>
              <p className="blog-post-description">
                You meet Hachiman Hikigaya—a loner, a cynic, someone who sees the world for what it is and doesn't try to sugarcoat it. Right from the start, you feel like this isn't going to be about typical romantic clichés or over-the-top comedy.....
              </p>
              <div className="blog-tags">
                <span className="blog-tag">Anime</span>
                <span className="blog-tag">Comedy</span>
                <span className="blog-tag">Romance</span>
                <Link className="blogcontentviewmore-button" to="/new-blog-home/article/1">
                  View More
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Right Section with Additional Posts */}
        <div className="blog-sidebar">
          {/* Post Preview 1 */}
          <div className="blog-sidebar-post">
            <Link to="/new-blog-home/article/5">
              <img
                className="blog-sidebar-image"
                src={Hinata5}
                alt="Haikyu: Rising Above All - Anime Review"
              />
            </Link>
            <div className="blog-sidebar-content">
              <p className="blog-sidebar-author"> • 18 Nov 2024</p>
              <Link to="/new-blog-home/article/5" className="blog-sidebar-title-link">
                <h3 className="blog-sidebar-title">Haikyu: Rising Above All</h3>
              </Link>
              <p className="blog-sidebar-description">
                Hinata Shoyo—a short guy in a sport dominated by height. Some people might hesitate to give Haikyu!! a try, but the way it....
              </p>
              <div className="blog-sidebar-tags">
                <span className="blog-sidebar-tag">Sports</span>
                <span className="blog-sidebar-tag">Volleyball</span>
                <Link className="blogcontentviewmore-button" to="/new-blog-home/article/5">
                  View More
                </Link>
              </div>
            </div>
          </div>

          {/* Post Preview 2 */}
          <div className="blog-sidebar-post">
            <Link to="/new-blog-home/article/2">
              <img
                className="blog-sidebar-image"
                src={Shigatsu}
                alt="Shigatsu wa Kimi no Uso - Your Lie in April Review"
              />
            </Link>
            <div className="blog-sidebar-content">
              <p className="blog-sidebar-author"> • 16 Oct 2024</p>
              <Link to="/new-blog-home/article/2" className="blog-sidebar-title-link">
                <h3 className="blog-sidebar-title">Shigatsu Kimi Your Lie April</h3>
              </Link>
              <p className="blog-sidebar-description">
                Gentle, slice-of-life storytelling that feels like a warm breeze on a quiet day. It draws you into the world of school corridors, music rooms,
                and the unspoken emotions of its characters.....
              </p>
              <div className="blog-sidebar-tags">
                <span className="blog-sidebar-tag">Anime</span>
                <span className="blog-sidebar-tag">Romance</span>
                <Link className="blogcontentviewmore-button" to="/new-blog-home/article/2">
                  View More
                </Link>
              </div>
            </div>
          </div>

          {/* Post Preview 3 */}
          <div className="blog-sidebar-post">
            <Link to="/new-blog-home/article/3">
              <img
                className="blog-sidebar-image"
                src={coachf}
                alt="Giant Killing Anime Review"
              />
            </Link>
            <div className="blog-sidebar-content">
              <p className="blog-sidebar-author"> • 02 Dec 2025</p>
              <Link to="/new-blog-home/article/3" className="blog-sidebar-title-link">
                <h3 className="blog-sidebar-title">Giant Killing: A Coach, a Dream, and the Underdog Spirit</h3>
              </Link>
              <p className="blog-sidebar-description">
                A Japanese coach who once managed to do
                something incredible in Europe—taking a struggling, overlooked team and lifting them
                to a higher division....
              </p>
              <div className="blog-sidebar-tags">
                <span className="blog-sidebar-tag">Football</span>
                <span className="blog-sidebar-tag">Strategy</span>
                <Link className="blogcontentviewmore-button" to="/new-blog-home/article/3">
                  View More
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogContent;
